import React from 'react';
import { Button, Table, Form, Header, Segment, Icon, Popup, Loader, Tab } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { FiltersOnStyle, IconHeader } from '../../Assets/util/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class AddStaff extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courseRoleTypes: [],
            professors: [],
            assistants: [],
            professorsList: [],
            leadStaff: [],
            assistantsList: [],
            staff: [],
            existingStaffIds: [],

            showAddForm: false,
        };

        this.addStaff = this.addStaff.bind(this);
        this.removeStaff = this.removeStaff.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getStaff = this.getStaff.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }

    componentDidMount() {
        console.log('1');
        this.getStaff();
        axios.get('course-role-types')
            .then(res => {
                this.setState({ courseRoleTypes: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch course role types.');
            });
    }

    resetForm() {
        this.setState({
            professorsList: '',
            assistantsList: '',
            leadStaff: ''
        });
    }

    getStaff() {
        console.log('2');
        this.setState({ loader: true });
        axios.get(`course/implementation/staff/${this.props.location.state.id}`)
            .then(ress => {
                console.log('3');
                const existingStaffIds = ress.data.map(el => el.employee.id);
                this.setState({ staff: ress.data, existingStaffIds });
                console.log('4', this.state.existingStaffIds);
                let obj = {};
                axios.post('employees/by-key/professor', { ...obj })
                    .then(res => {
                        console.log('5');
                        this.setState({ loader: false });
                        const professors = res.data.filter(el => !this.state.existingStaffIds.includes(el.id)).map(el => ({
                            ...el, key: el.id, value: { value: el.id, key: el.id, text: el.firstName + ' ' + el.lastName }, text: el.firstName + ' ' + el.lastName
                        }));
                        console.log('6', professors);
                        this.setState({ professors });
                        console.log('7');
                    })
                    .catch(err => {
                        console.log('Failed to fetch professors');
                    });

                axios.post('employees/by-key/all', { ...obj })
                    .then(res => {
                        this.setState({ loader: false });
                        const assistants = res.data.filter(el => !this.state.existingStaffIds.includes(el.id)).map(el => ({
                            ...el, key: el.id, value: el.id, text: el.firstName + ' ' + el.lastName
                        }));
                        this.setState({ assistants });
                    })
                    .catch(err => {
                        console.log('Failed to fetch assistants');
                    });
            })
            .catch(err => {
                console.log('Failed to fetch staff.');
            });
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    addStaff(professorsList, assistantsList, leadStaff) {
        let staffList = [];

        // if (leadStaff) {
        //     leadStaff.map(el => (
        //         staffList.push({
        //             courseImplementation: { id: this.props.location.state.id },
        //             leadStaff: true,
        //             employee: { id: el },
        //             courseRoleType: { id: this.state.courseRoleTypes.find(e => e.name === 'profesor').id }
        //         })
        //     ));
        // }

        if (professorsList) {
            professorsList.map(el => (
                staffList.push({
                    courseImplementation: { id: this.props.location.state.id },
                    leadStaff: !!this.state.leadStaff.find(e => e === el.value),
                    employee: { id: el.value },
                    courseRoleType: { id: this.state.courseRoleTypes.find(e => e.name === 'profesor').id }
                })
            ));
        }

        if (assistantsList) {
            assistantsList.map(el => (
                staffList.push({
                    courseImplementation: { id: this.props.location.state.id },
                    leadStaff: false,
                    employee: { id: el },
                    courseRoleType: { id: this.state.courseRoleTypes.find(e => e.name === 'asistent').id }
                })
            ));
        }


        if (!leadStaff) {
            toast('Morate odabrati nosioca predmeta!');
        } else {
            axios.post('course/implementation/staff/', [...staffList])
                .then(res => {
                    toast('Uspješno ste dodali osoblje na predmet.');
                    this.setState({ showAddForm: false });
                    this.getStaff();
                    this.resetForm();
                })
                .catch(err => {
                    toast('Došlo je do greške! Dodavanje osoblja na predmet nije uspjelo.');
                });
        }
    }

    removeStaff(id) {
        let obj = { id };
        this.setState({ loader: true });
        axios.delete('course/implementation/remove-staff/', { data: obj })
            .then(res => {
                toast('Uspješno ste uklonili osoblje sa predmeta.');
                this.setState({ loader: false });
                this.getStaff();
            })
            .catch(err => {
                if (err.response.data === 'Staff is on sga!') {
                    toast('Profesor je zadužen za ispit na ovom predmetu. Nije moguće ukloniti osoblje.');
                } else {
                    toast('Došlo je do greške! Uklanjanje osoblja sa predmeta nije uspjelo.');
                }
            });
    }


    render() {
        return (
            <div>
                {/* <Header as="h1">{localStorage.getItem('courseBasicName')}</Header> */}
                <Header as="h1">Osoblje</Header>

                <Segment.Group raised>
                    <Segment clearing>
                        {(localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu') || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') ?
                            <Header as="h3">
                                {localStorage.getItem('courseBasicName')}
                                <Header.Subheader floated="left">
                                    {(localStorage.getItem('courseComment')) === 'null' ? 'Predmet' : localStorage.getItem('courseComment')}
                                </Header.Subheader>
                            </Header> :
                            <Header as="h3">
                                {/* Osoblje na predmetu */}
                                {!this.state.showAddForm && <Header style={IconHeader} floated="right" >

                                    <Button
                                        color="blue"
                                        floated="right"
                                        icon
                                        disabled={!this.props.location.state.thirdCycle && !this.props.location.state.specialist && this.props.location.state.activeIndex === 1}
                                        labelPosition="right"
                                        size="small"
                                        style={FiltersOnStyle}
                                        onClick={() => this.setState({ showAddForm: true })}
                                    ><Icon className="user plus" />
                                        Dodavanje osoblja
                                    </Button>
                                </Header>}
                                {localStorage.getItem('courseBasicName')}
                                <Header.Subheader floated="left">
                                    {(localStorage.getItem('courseComment')) === 'null' ? 'Predmet' : localStorage.getItem('courseComment')}
                                </Header.Subheader>
                            </Header>}
                    </Segment>
                    {this.state.showAddForm && <Segment>


                        <Segment clearing secondary>
                            <Form noValidate>

                                <Form.Field>
                                    <label>Profesori</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite profesora/e"
                                        value={this.state.professorsList}
                                        onChange={this.handleInputChange}
                                        name="professorsList"
                                        options={this.state.professors}
                                        search
                                        fluid
                                        selection
                                        multiple
                                    />
                                </Form.Field>
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>Nosilac / nosioci predmeta</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odaberite profesora/e"
                                            value={this.state.leadStaff}
                                            onChange={this.handleInputChange}
                                            name="leadStaff"
                                            options={this.state.professorsList}
                                            search
                                            fluid
                                            selection
                                            multiple
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Asistenti</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odaberite asistenta"
                                            value={this.state.assistantsList}
                                            onChange={this.handleInputChange}
                                            name="assistantsList"
                                            options={this.state.assistants}
                                            search
                                            fluid
                                            selection
                                            multiple
                                        />
                                    </Form.Field>
                                </Form.Group>


                                <Button basic="true" color="blue" onClick={() => this.setState({ showAddForm: false })} floated="right">Odustani</Button>
                                <Button
                                    floated="right"
                                    color="blue"
                                    onClick={
                                        () => {
                                            this.addStaff(
                                                this.state.professorsList,
                                                this.state.assistantsList,
                                                this.state.leadStaff
                                            );
                                        }
                                    }
                                >
                                    Dodaj
                                </Button>
                            </Form>
                        </Segment>

                    </Segment>}

                    <Segment>

                        { this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                            this.state.staff.length ?
                                <Table celled selectable compact>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell width="6">
                                                Prezime i ime
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width="5">
                                                Uloga na predmetu
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width="2">
                                                Nosilac predmeta
                                            </Table.HeaderCell >
                                            {(localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja')) && <Table.HeaderCell width="2" />}
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body> {this.state.staff.map((el, index) =>
                                        (<Table.Row key={el.id}>
                                            <Table.Cell verticalAlign="middle" width="7">
                                                {el.employee.person.lastName} {el.employee.person.firstName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" width="6">
                                                {el.courseRoleType.name}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" width="2">
                                                {el.leadStaff ? 'DA' : 'NE'}
                                            </Table.Cell>
                                            {(localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja')) &&
                                            <Table.Cell verticalAlign="middle" textAlign="center" width="2" >
                                                <Popup
                                                    content={'Ukloni ' + el.courseRoleType.name + 'a sa predmeta'}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            disabled={(!this.props.location.state.thirdCycle && !this.props.location.state.specialist && this.props.location.state.activeIndex === 1) || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')}
                                                            icon="user times"
                                                            size="tiny"
                                                            color="red"
                                                            onClick={() => this.removeStaff(el.id)}
                                                        />

                                                    }
                                                />

                                                {/* <Button color="red" basic="true" onClick={() => this.removeStaff(el.id)}> */}
                                                {/*    Ukloni {el.courseRoleType.name}a sa predmeta */}
                                                {/* </Button> */}
                                            </Table.Cell>}

                                        </Table.Row>))}
                                    </Table.Body>
                                </Table>
                                : <p>Nema osoblja na ovom predmetu.</p>
                        }
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/CreateCourseImplementation/AddStaff.js